webpackJsonp([1,2],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(55),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__example_choice_color__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__example_choice_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__example_choice_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__example_circular_nav__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__example_circular_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__example_circular_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__example_common_bus__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    exampleChoiceColor: __WEBPACK_IMPORTED_MODULE_0__example_choice_color___default.a,
    exampleCircularNav: __WEBPACK_IMPORTED_MODULE_1__example_circular_nav___default.a
  },
  data: function data() {
    return {
      colorIndex: 0,
      navIndex: 0,
      color: ''
    };
  },

  computed: {
    theme: function theme() {
      return {
        backgroundColor: this.color
      };
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__example_common_bus__["a" /* default */].$on('setTheme', function (_ref) {
      var index = _ref.index,
          color = _ref.color;

      _this.colorIndex = index;
      _this.color = color;
    });
    __WEBPACK_IMPORTED_MODULE_2__example_common_bus__["a" /* default */].$on('setNav', function (index) {
      _this.navIndex = index;
    });
  }
};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var colors = ['#1ba6cc', '#189ba7', '#98c6ae', '#45a270'];

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'choiceColor',
  data: function data() {
    return {
      color: colors[0]
    };
  },

  props: {
    colors: {
      default: colors
    },
    radius: {
      default: '10em'
    }
  },
  computed: {
    colorBg: function colorBg() {
      return {
        backgroundColor: this.color
      };
    },
    containerSize: function containerSize() {
      return {
        width: 'calc(2 * ' + this.radius + ')',
        height: 'calc(2 * ' + this.radius + ')'
      };
    }
  },
  methods: {
    setColor: function setColor(color) {
      var index = this.colors.indexOf(color);
      this.color = color;
      this.$emit('updateColor', { index: index, color: color });
    },
    setItem: function setItem(index) {
      var rotate = index * 360 / this.colors.length + 'deg';
      var skew = 90 - 360 / this.colors.length + 'deg';

      return {
        backgroundColor: this.colors[index],
        transform: 'rotate(' + rotate + ') skew(' + skew + ')'
      };
    }
  }
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'circularNav',
  data: function data() {
    return {
      isOpen: false,
      size: {}
    };
  },

  props: {
    navs: {
      type: Array,
      require: true
    },
    radius: {
      type: String,
      default: '10em'
    },
    color: {
      type: String,
      default: '#754481'
    }
  },
  computed: {
    colorT: function colorT() {
      return {
        color: this.isOpen ? this.color : '#fff',
        backgroundColor: this.isOpen ? '#fff' : this.color
      };
    },
    containerSize: function containerSize() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        bottom: 'calc(-' + this.radius + ' - 1px)'
      }, this.size);
    },
    anchorStyle: function anchorStyle() {
      var rotate = '-' + (90 - 90 / this.navs.length) + 'deg';
      var skew = '-' + (90 - 180 / this.navs.length) + 'deg';
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        transform: 'skew(' + skew + ') rotate(' + rotate + ')',
        right: '-' + this.radius,
        bottom: '-' + this.radius
      }, this.size);
    },
    navTransform: function navTransform() {
      return {
        transform: 'translateX(-50%) scale(' + (this.isOpen ? 1 : 0.01) + ')'
      };
    }
  },
  methods: {
    setNav: function setNav(index) {
      this.$emit('updateNav', index);
    },
    setItem: function setItem(index) {
      var rotate = index * 180 / this.navs.length + 'deg';
      var skew = 90 - 180 / this.navs.length + 'deg';

      return {
        backgroundColor: this.color,
        transform: 'rotate(' + rotate + ') skew(' + skew + ')'
      };
    },
    toggle: function toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.size, {
      width: 'calc(2 * ' + this.radius + ')',
      height: 'calc(2 * ' + this.radius + ')'
    });
  }
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_choice_color__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_choice_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_choice_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_bus__ = __webpack_require__(1);





var colors = ['#1ba6cc', '#189ba7', '#98c6ae', '#45a270', '#7cb325', '#eb9826', '#d8541f', '#d40c45', '#cf6d90', '#980a58', '#da565f', '#754481', '#c11067'];

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'exampleChoiceColor',
  components: {
    choiceColor: __WEBPACK_IMPORTED_MODULE_0__components_choice_color___default.a
  },
  data: function data() {
    return {
      colors: colors
    };
  },

  methods: {
    updateColor: function updateColor(_ref) {
      var index = _ref.index,
          color = _ref.color;

      __WEBPACK_IMPORTED_MODULE_1__common_bus__["a" /* default */].$emit('setTheme', { index: index, color: color });
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__common_bus__["a" /* default */].$emit('setTheme', { index: 0, color: this.colors[0] });
  }
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_circular_nav__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_circular_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_circular_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_bus__ = __webpack_require__(1);





var navs = [{
  label: 'Discover',
  href: 'javascript:void(0)',
  icon: 'icon-discover'
}, {
  label: 'Home',
  href: 'javascript:void(0)',
  icon: 'icon-home'
}, {
  label: 'My',
  href: 'javascript:void(0)',
  icon: 'icon-my'
}];

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'exampleCircularNav',
  components: {
    circularNav: __WEBPACK_IMPORTED_MODULE_0__components_circular_nav___default.a
  },
  data: function data() {
    return {
      index: 0,
      color: '',
      navs: navs
    };
  },

  computed: {
    theme: function theme() {
      return {
        backgroundColor: this.color
      };
    }
  },
  methods: {
    updateNav: function updateNav(index) {
      this.index = index;
      __WEBPACK_IMPORTED_MODULE_1__common_bus__["a" /* default */].$emit('setNav', index);
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__common_bus__["a" /* default */].$on('setTheme', function (_ref) {
      var color = _ref.color;

      _this.color = color;
    });
  }
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(56),
  /* scopeId */
  "data-v-4a468d22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  "data-v-8e0279a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  "data-v-7187ca6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(57),
  /* scopeId */
  "data-v-4fa9d42b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "current",
    style: (_vm.theme)
  }, [_c('p', [_vm._v("Color Index: " + _vm._s(_vm.colorIndex))]), _c('p', [_vm._v("Nav Index: " + _vm._s(_vm.navIndex))])]), _c('example-choice-color'), _c('example-circular-nav')], 1)
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "theme-container",
    style: (_vm.containerSize)
  }, [_c('ul', {
    staticClass: "colors-container"
  }, _vm._l((_vm.colors), function(color, index) {
    return _c('li', {
      staticClass: "color-block",
      style: (_vm.setItem(index)),
      on: {
        "click": function($event) {
          _vm.setColor(color)
        }
      }
    })
  })), _c('div', {
    staticClass: "faux-border"
  }, [_c('div', {
    staticClass: "chosen-color",
    style: (_vm.colorBg)
  })])])
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "circular-nav"
    }
  }, [_c('circular-nav', {
    attrs: {
      "navs": _vm.navs,
      "color": _vm.color,
      "radius": "8em"
    },
    on: {
      "updateNav": _vm.updateNav
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "theme"
    }
  }, [_c('choice-color', {
    attrs: {
      "colors": _vm.colors,
      "radius": "10em"
    },
    on: {
      "updateColor": _vm.updateColor
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-container"
  }, [_c('div', {
    staticClass: "nav-wrapper",
    style: ([_vm.containerSize, _vm.navTransform])
  }, [_c('ul', {
    staticClass: "nav-tabbar"
  }, _vm._l((_vm.navs), function(nav, index) {
    return _c('li', {
      staticClass: "nav-item",
      style: (_vm.setItem(index)),
      on: {
        "click": function($event) {
          _vm.setNav(index)
        }
      }
    }, [_c('a', {
      style: (_vm.anchorStyle),
      attrs: {
        "href": nav.href || "javascript:void(0)"
      }
    }, [(nav.icon) ? _c('span', {
      staticClass: "iconfont",
      class: nav.icon
    }) : _vm._e(), (nav.label) ? _c('span', {
      staticClass: "nav-item-label"
    }, [_vm._v(_vm._s(nav.label))]) : _vm._e()])])
  }))]), _c('div', {
    staticClass: "nav-toggle",
    style: (_vm.colorT),
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.isOpen ? '-' : '+'))]), _c('div', {
    staticClass: "nav-overlay",
    class: _vm.isOpen ? "on-overlay" : "",
    on: {
      "click": _vm.toggle
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ })
],[62]);


// WEBPACK FOOTER //
// static/js/app.0ef03d87aa7a6266db8e.js